/**
 * ヘッダーヘルプメニュー用の型と初期定義。
 * 将来API取得に差し替える場合は、この配列の供給元をサービスに変更する。
 */

export interface HelpMenuItem {
  id: string;
  label: string;
  url: string;
  enabled: boolean;
}

/**
 * 初期メニュー定義（埋め込み）。
 * URLは environment 等で上書きする場合は HeaderComponent でマージすること。
 */
export const HELP_MENU_ITEMS: HelpMenuItem[] = [
  { id: 'usage', label: '使い方', url: '', enabled: true },
  { id: 'faq', label: 'よくあるご質問', url: '', enabled: true },
  { id: 'contact', label: 'お問い合わせ', url: '', enabled: true },
];
